import React from 'react';
import { Box } from '@mui/material';
import GridLayer from './GridLayer';
import RadarLayer from './RadarLayer';
import ParticlesLayer from './ParticlesLayer';

const IntelligenceBackground: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        bgcolor: '#040b08',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <GridLayer />
      <RadarLayer />
      <ParticlesLayer />
      
      {/* Vignette/Depth Gradients */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 50% 50%, transparent 0%, rgba(4, 11, 8, 0.4) 100%)',
          zIndex: 4,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '40vh',
          background: 'linear-gradient(to top, #040b08, transparent)',
          zIndex: 5,
        }}
      />
    </Box>
  );
};

export default IntelligenceBackground;
